// extracted by mini-css-extract-plugin
export var button = "button-module--button--KCsdZ";
export var buttonsGroup = "button-module--buttonsGroup--+tPIa";
export var codeAsLink = "button-module--codeAsLink--cyiiu";
export var darkButton = "button-module--darkButton--gqVhH";
export var links = "button-module--links--0uKag";
export var moving = "button-module--moving--3Cfwn";
export var pinkButton = "button-module--pinkButton--J3bsf";
export var primaryButton = "button-module--primaryButton--veRGX";